<div class="container">
  <div class="buttons-container" *ngIf="!readonly">
    <button mat-raised-button
            action-button
            color="primary"
            [action]="findInGus.bind(this)">
      Wyszukaj dane firmy w bazie GUS
    </button>
  </div>
  <form [formGroup]="companyForm" (ngSubmit)="updateCompany()">
    <mat-form-field appearance="outline">
      <mat-label>Nazwa</mat-label>
      <input [readonly]="readonly" matInput formControlName="companyName" required/>
      <mat-error *ngIf="companyForm.get('companyName').hasError('required')">
        Podaj nazwę firmy
      </mat-error>
    </mat-form-field>
    <div class="double-field-container">
      <mat-form-field appearance="outline">
        <mat-label>NIP</mat-label>
        <input [readonly]="readonly" matInput formControlName="nip"/>
        <mat-error *ngIf="companyForm.get('nip').hasError('maxlength') ||
                          companyForm.get('nip').hasError('minlength') ||
                          companyForm.get('nip').hasError('pattern')">
          Niepoprawny numer NIP
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>REGON</mat-label>
        <input [readonly]="readonly" matInput formControlName="regon"/>
        <mat-error *ngIf="companyForm.get('regon').hasError('maxlength') ||
                          companyForm.get('regon').hasError('minlength') ||
                          companyForm.get('regon').hasError('pattern')">
          Niepoprawny numer REGON
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>KRS</mat-label>
        <input [readonly]="readonly" matInput formControlName="krs"/>
        <mat-error *ngIf="companyForm.get('krs').hasError('maxlength') ||
                          companyForm.get('krs').hasError('minlength')">
          Niepoprawny numer KRS
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>
          Zewnętrzne ID
        </mat-label>
        <input matInput formControlName="individualNumber" id="individualNumber"/>
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>Forma prawna</mat-label>
      <mat-select [disabled]="readonly" formControlName="legalForm">
        <mat-option value="STANDARD">Zwykła firma</mat-option>
        <mat-option value="CIVIL_PARTNERSHIP">Spółka cywilna</mat-option>
      </mat-select>
    </mat-form-field>
    <section *ngIf="isCivilPartnership" class="civil-partnership-partners">
      <h2>Wspólnicy</h2>
      <div *ngFor="let partner of civilPartnershipPartners" class="multi-field-step">
        <span>{{ partner.companyName || (partner.name + ' ' + partner.secondName + ' ' + partner.surname) }}<ng-container *ngIf="partner.pesel"> ({{ partner.pesel }})</ng-container></span>
        <button *ngIf="!readonly" type="button" mat-icon-button matTooltip="Edytuj wspólnika" (click)="editCivilPartnershipPartner(partner.id)">
          <mat-icon>edit</mat-icon>
        </button>
        <button *ngIf="!readonly" type="button" mat-icon-button color="warn" matTooltip="Usuń wspólnika" (click)="removeCivilPartnershipPartner(partner.id)">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <button *ngIf="!readonly" type="button" mat-stroked-button color="primary" [disabled]="!company.lessorId" (click)="addCivilPartnershipPartner()">
        <mat-icon>add</mat-icon>
        Dodaj wspólnika
      </button>
      <mat-error *ngIf="civilPartnershipPartners.length === 0">Dodaj co najmniej jednego wspólnika</mat-error>
    </section>
    <button *ngIf="standalone"
            mat-raised-button
            color="primary"
            [disabled]="!companyForm.valid || (isCivilPartnership && civilPartnershipPartners.length === 0)"
            type="submit"
            id="submit">
      <span class="color-white">
        Zmień dane
      </span>
    </button>
    <div class="emails">
      <h1>Emaile</h1>
      <app-customer-email *ngFor="let email of company.emails.data" [email]="email"
                          (deleteEvent)="deleteEmail($event)"></app-customer-email>
      <button mat-raised-button
              class="width-100 create-button"
              type="button"
              color="primary"
              action-button
              [action]="addEmail.bind(this)">
        Dodaj email
      </button>
    </div>
    <div class="phones">
      <h1>Telefony</h1>
      <app-customer-phone *ngFor="let phone of company.phones.data" [phone]="phone"
                          (eventDelete)="deletePhone($event)"></app-customer-phone>
      <button mat-raised-button
              class="width-100 create-button"
              type="button"
              color="primary"
              action-button
              [action]="addPhone.bind(this)">
        Dodaj telefon
      </button>
    </div>
    <app-address-info *ngFor="let address of company.addresses.data" [address]="address" (eventDelete)="deleteAddress($event)"
                      [label]="address.type.label"></app-address-info>
    <button mat-raised-button
            class="width-100 create-button"
            type="button"
            color="primary"
            action-button
            [action]="addAddress.bind(this)">
      Dodaj adres
    </button>
    <h1>Grupa zlecającego</h1>
    <app-lessor-group-info [company]="company"></app-lessor-group-info>
    <button
      mat-raised-button
      class="width-100 create-button"
      type="button"
      color="primary"
      action-button
      [action]="create.bind(this)">
      Utwórz nową grupę
    </button>

  </form>
</div>
